module.exports = __webpack_public_path__ + "img/dotaLogo.5cce1c12.svg";